import { Icon } from '@foam/buoy/src/components/Icon/Icon';
import { TextLink } from '@foam/buoy/src/components/TextLink/TextLink';
import { Tooltip } from '@foam/buoy/src/components/Tooltip/Tooltip';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import {
  SOCIAL_PLATFORMS_NAMES,
  SupportedPlatforms,
} from '~/constants/platforms';
import { routes } from '~/core/router';

const LABEL_TEXT = 'Indicative audience data. Best read directionally.';
const TOOLTIP_TEXT = 'Indicative audience data. Best read directionally.';
const BUTTON_TEXT = 'Connect to enable verified API metrics';

interface STMPredictionLabelProps {
  isSTMEnabled: boolean;
  platform: SupportedPlatforms;
}

export const STMPredictionLabel = ({
  isSTMEnabled = false,
  platform,
}: STMPredictionLabelProps) => {
  const router = useRouter();
  const creatorSlug = router.query.creatorSlug as string;

  const redirectToConnectPlatformsPage = useCallback(async () => {
    if (creatorSlug) {
      await router.push(
        {
          pathname: routes.talentProfilePlatformConnections(creatorSlug),
          query: { creatorSlug },
        },
        undefined,
        { shallow: true },
      );
    }
  }, [creatorSlug]);

  return !isSTMEnabled ? (
    <p className="text-12 font-400 text-neutral-500">
      {`Verified metrics from ${SOCIAL_PLATFORMS_NAMES[platform]}'s API`}
    </p>
  ) : (
    <p className="flex items-center text-12 font-400 text-neutral-500">
      <span className="inline-flex items-center gap-1">
        <span>{LABEL_TEXT}</span>
        <Tooltip content={TOOLTIP_TEXT} placement="top">
          <span
            className="inline-flex items-center justify-center text-neutral-500"
            aria-label="Indicative audience data info"
          >
            <Icon name="Info" className="text-14" />
          </span>
        </Tooltip>
      </span>

      {creatorSlug && (
        <TextLink
          size="body-md"
          className="ml-2 font-300 text-link-primary-text-color-default"
          onClick={redirectToConnectPlatformsPage}
        >
          {BUTTON_TEXT}
        </TextLink>
      )}
    </p>
  );
};
